import { useConnectModal } from '@rainbow-modules/hooks';
import FormModal from 'components/FormModal';
import { ADD_EDIT_CALENDAR_EVENT_TYPE } from '../../../../../constants';
import Fields from './fields';

const AddEditEventTypeForm = () => {
    const { ...connectedModalProps } = useConnectModal(ADD_EDIT_CALENDAR_EVENT_TYPE);

    return (
        <FormModal
            borderRadius="semi-square"
            size="medium"
            fields={Fields}
            {...connectedModalProps}
        />
    );
};

export default AddEditEventTypeForm;
